import React from 'react'
import { FolderPlus, Upload } from 'lucide-react'
import { Button } from 'components/ui/button'

interface DocumentLibraryEmptyStateProps {
	onUpload?: () => void
}

const DocumentLibraryEmptyState: React.FC<DocumentLibraryEmptyStateProps> = ({
	onUpload,
}) => (
	<div className="flex flex-col items-center justify-center text-center py-16 px-4">
		<div className="rounded-full bg-[#0080fe]/10 p-4 mb-4">
			<FolderPlus className="w-10 h-10 text-[#0080fe]" />
		</div>
		<h3 className="text-lg font-semibold text-gray-900 mb-1">
			No documents yet
		</h3>
		<p className="text-sm text-gray-600 mb-6 max-w-sm">
			Upload Word, Excel, PowerPoint, or PDFs to start your project
			document library. Each upload is versioned, previewable, and
			shareable.
		</p>
		{onUpload && (
			<Button
				type="button"
				onClick={onUpload}
				className="gap-2"
			>
				<Upload className="w-4 h-4" />
				Upload your first document
			</Button>
		)}
	</div>
)

export default DocumentLibraryEmptyState
